import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "./firebase";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Auth from "./components/Auth";
import ResumeForm from "./components/ResumeForm";
import ResumePreview from "./components/ResumePreview";
import Dashboard from "./components/Dashboard";
import "./App.css";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return unsubscribe; // Cleanup subscription
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* If user is logged in, redirect to dashboard, else show auth */}
          <Route 
            path="/" 
            element={user ? <Navigate to="/dashboard" /> : <Auth />} 
          />
          <Route 
            path="/auth" 
            element={user ? <Navigate to="/dashboard" /> : <Auth />} 
          />
          <Route 
            path="/dashboard" 
            element={user ? <Dashboard user={user} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/create" 
            element={user ? <ResumeForm /> : <Navigate to="/" />} 
          />
          <Route 
            path="/edit/:id" 
            element={user ? <ResumeForm /> : <Navigate to="/" />} 
          />
          <Route 
            path="/preview/:id" 
            element={user ? <ResumePreview /> : <Navigate to="/" />} 
          />
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;